import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Textfit } from 'react-textfit';
import ResponsiveImage from '../layout/images/responsive';
import Text from '../text/text';
import styles from './billboard.scss';

class Billboard extends Component {
  render() {
    const { visual, headline, headlineText, color, height, width, page } = this.props;
    let ratio = 50;

    if (height === 'Single' && width === 'Full') {
      ratio = 25;
    }

    const linkToPage = page !== undefined ? page.fields.slug : '#';
    const title = headlineText || headline;

    console.log(title);

    return (
      <section className={styles.section} data-height={height.toLowerCase()} data-width={width.toLowerCase()}>
        <NavLink to={linkToPage} className={styles.billboard} disabled={page === undefined}>
          {( title &&
            <div className={styles.headline}>
              <div className={styles.headlineWrapper} style={{ color }}>
                <Textfit mode="multi" max={35} style={{height: '100%'}}>
                  <Text text={title}/>
                </Textfit>
              </div>
            </div>
          )}
          <div className={styles.visual}>
            <ResponsiveImage image={visual} showCaption={false} ratio={ratio}/>
          </div>
        </NavLink>
      </section>
    );
  }
}

Billboard.propTypes = {
  visual: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  headline: PropTypes.string,
  headlineText: PropTypes.string,
  page: PropTypes.object
}

export default Billboard;



// WEBPACK FOOTER //
// ./src/components/billboard/billboard.jsx